import { FC } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
} from '@chakra-ui/react';

export interface ErrorNotificationProps {
  title: string;
  description: string;
}

export const ErrorNotification: FC<ErrorNotificationProps> = ({
  title,
  description,
}): JSX.Element => (
  <Alert status="error">
    <AlertIcon />
    <Box>
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Box>
  </Alert>
);
